export const NEWS_FEED_PULLING = '/api/v1/feed/pulling';
export const NEWS_FEED_DETAIL = '/api/v1/news/messageId/details';
export const NEWS_FEED_LIST = '/api/v1/news/list';
export const NEWS_FEED_LIST_PINNED = '/api/v1/news/list-pinned';
